import { helper } from "@ember/component/helper";

export type Color = "green" | "indigo" | "blue" | "orange" | "red" | "pink" | "gray";

export function colors([color]: [Color?]): string {
  switch (color) {
    case "green":
      return "bg-green-100 text-black border border-green-100";
    case "indigo":
      return "bg-indigo-700 text-white border border-indigo-700";
    case "blue":
      return "bg-indigo-100 text-black border border-indigo-100";
    case "orange":
      return "bg-orange-200 text-black border border-orange-200";
    case "red":
      return "bg-red-100 text-black border border-red-100";
    case "pink":
      return "bg-pink-100 text-black border border-pink-100";
    case "gray":
    default:
      return "bg-gray-200 text-black border border-gray-200";
  }
}

export default helper(colors);
